import { render, staticRenderFns } from "./coin_weblog.vue?vue&type=template&id=30e629ea&"
import script from "./coin_weblog.vue?vue&type=script&lang=js&"
export * from "./coin_weblog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DetailWeblog: require('/src/components/detail/mobile/detail_weblog.vue').default})
